export const insertIntoIndex = (array, element, index) => array.splice(index, 0, element);
/**
 * Removes an element from an array, returning the deleted element.
 */
export const removeElement = (array, index) => array.splice(index, 1)[0];
//# sourceMappingURL=array.js.map
